import React from "react";
import "./style.css";
import {MONEY_BACK_POLICY, PRIVACY_POLICY, TERMS_OF_USE} from "../../../../../enum/NavigationEnum";

import { Image } from "../../../../../components/Image";
export const MobileAgeRange = ({
                             clickNext = () => {},
                           setDisplayNav = () => {},
                           }) => {

  return (
    <div className="age-range" data-model-id="16725:763">

      <div className="contents">

        <div className="title">
          <p className="chair-yoga">
            <span className="text-wrapper-2">Intermittent Fasting</span>
          </p>

          <div className="text">
            <div className="subtitle">BASED ON YOUR AGE</div>

            <div className="description">1-minute quiz</div>
          </div>
        </div>

        <div className="card">
          <div className="card-2" onClick={() => {clickNext("16-29")}}>
            <div className="age-wrapper">
              <div className="card-age">
                <div className="age-2">Age:16~29</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/frame-3.svg" alt="Frame" className="play-icon" />
              </div>
            </div>


            <Image src="/static/image/questionnaire/fasting/ageRange/age_1.png" alt="Img" className="img" />
          </div>

          <div className="card-2" onClick={() => {clickNext("30-39")}} >
            <div className="age-wrapper">
              <div className="card-age">
                <div className="age-2">Age: 30~39</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/frame-3.svg" alt="Frame" className="play-icon" />
              </div>
            </div>

            <Image src="/static/image/questionnaire/fasting/ageRange/img35-49.png" alt="Img" className="img" />
          </div>

          <div className="card-2" onClick={() => {clickNext("40-49")}}>
            <div className="age-wrapper">
              <div className="card-age">
                <div className="age-2">Age: 40~49</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/frame-3.svg" alt="Frame" className="play-icon" />
              </div>
            </div>


            <Image src="/static/image/questionnaire/fasting/ageRange/img_3.png" alt="Img" className="img" />
          </div>

          <div className="card-2" onClick={() => {clickNext("50+")}}>
            <div className="age-wrapper">
              <div className="card-age">
                <div className="age-2">Age: 50+</div>

                <Image src="/static/image/questionnaire/fasting/ageRange/frame-3.svg" alt="Frame" className="play-icon" />
              </div>
            </div>


            <Image src="/static/image/questionnaire/fasting/ageRange/img_4.png" alt="Img" className="img" />
          </div>
        </div>

        <div className="title">
          <p className="terms">
            <span className="span">By </span>

            <span className="text-wrapper-3">
              choosing your age and continuing
            </span>

            <span className="span"> you agree to our</span>

            <span className="text-wrapper-4">&nbsp;</span>

            <span className="text-wrapper-5" onClick={() => {setDisplayNav(TERMS_OF_USE)}}>Terms of Service</span>

            <span className="text-wrapper-4"> | </span>

            <span className="text-wrapper-5" onClick={() => {setDisplayNav(PRIVACY_POLICY)}}>Privacy Policy</span>

            <span className="span">&nbsp;</span>

            <span className="text-wrapper-4">|</span>

            <span className="span">&nbsp;</span>

            <span className="text-wrapper-5" onClick={() => {setDisplayNav(MONEY_BACK_POLICY)}}>Refund Policy</span>

            <span className="span"> Please review before continuing</span>
          </p>
        </div>
      </div>
    </div>
  );
};
